// Links out of the Reports page carry where they came from, filters included,
// in the URL. That way "Back to report" also works after a reload or in a new tab.

// Only a Reports address is accepted, so a crafted link can't send people elsewhere.
const REPORT_URL = /^\/reports(\?[^#]*)?$/;

// reportLink is the address of path, with a way back to the report at reportUrl.
export function reportLink(path, reportUrl) {
  return `${path}?back=${encodeURIComponent(reportUrl)}`;
}

// reportBackUrl reads the report to go back to from a query string, or null.
export function reportBackUrl(search) {
  const back = new URLSearchParams(search || "").get("back");
  return back && REPORT_URL.test(back) ? back : null;
}
